import React, { useState } from 'react';
import { BaseAdSetForm } from './BaseAdSetForm';
import { AttributionWindowSection, buildAttributionSpec } from './AttributionWindowSection';
import { ODAX_MATRIX, GOAL_LABEL } from './odaxMatrix';

const AWARENESS_LOCATION = ODAX_MATRIX.OUTCOME_AWARENESS[0];

export const AwarenessAdSetForm: React.FC = () => {
  // Awareness only has one location (no destination picker) and only
  // supports a 1-day click attribution window — view-through doesn't
  // apply for reach/impression-only objectives.
  const [clickWin, setClickWin] = useState('1');
  const extraPayload = () => ({
    attribution_spec: buildAttributionSpec(clickWin, '0'),
  });

  const goalOptions = AWARENESS_LOCATION.goals.map((g) => ({
    code: g,
    label: GOAL_LABEL[g] ?? g,
  }));

  return (
    <BaseAdSetForm
      optimizationGoals={goalOptions}
      extraPayload={extraPayload}
      expectedObjective="OUTCOME_AWARENESS"
    >
      <AttributionWindowSection
        clickWin={clickWin}
        setClickWin={setClickWin}
        viewWin="0"
        setViewWin={() => undefined}
        hideViewThrough
        hint="Awareness ad sets only support a click-through window. Default: 1 day click."
      />
    </BaseAdSetForm>
  );
};
